module.exports = __webpack_public_path__ + "fbfd7d0b4b6de91a50e10d7c84f1e239.png";